
import React, { useEffect, useState } from 'react';
import { TabMenu } from 'primereact/tabmenu';
export default function TabMenuElement(props) {

    useEffect(()=>{
        
    },[props.items])

    return (
        <div className='portfolio-tabs'>
            <TabMenu model={props.items} activeIndex={props.activeIndex} onTabChange={props.onTabChange} />
            
        </div>
    )
}